import type { FunctionComponent } from 'react';
import { useIntl } from 'react-intl';

import NewApplicationSwitcherIcon from '@atlaskit/icon/core/app-switcher';

interface Props {
  dangerous_className?: string;
}

export const AtlassianAppSwitcherIcon: FunctionComponent<Props> = ({
  dangerous_className,
}) => {
  const intl = useIntl();
  return (
    <span className={dangerous_className}>
      <NewApplicationSwitcherIcon
        color="currentColor"
        label={intl.formatMessage({
          id: 'templates.cross_flow.switch to',
          defaultMessage: 'Switch to…',
          description: 'Aria label for the Atlassian App Switcher button',
        })}
        spacing="spacious"
        testId="NewApplicationSwitcherIcon"
      />
    </span>
  );
};
